// extracted by mini-css-extract-plugin
module.exports = {"marquee":"marquee_marquee__MIa8l","marquee-copy":"marquee_marquee-copy__FvrTl","marquee-container":"marquee_marquee-container__Xcn91"};